import moment from 'moment'
import { createSelector } from 'reselect'
import { Play } from '__generated__/api-types-and-hooks'
import { get, isArray } from 'lodash'
import { IAssessmentQuestion } from 'types'

export const getplayData = (state) => state.playBook.dashboardList
export const getAssessmentPlayData = (state) => state.playBook.assessmentPlayList
export const getAssessmentQuestion = (state) => state.owner.assessmentQuestion
export const getValue = (state) => state.play.play

export const selectPlayBook = createSelector(
  [getplayData],
  (
    dashboardList
  ): {
    firstPlay: Play | null
    lockedPlays: Play[]
    unlockedPlays: Play[]
  } => {
    const plays = dashboardList.plays || ([] as Play[])
    return {
      firstPlay: plays?.[0] || {},
      lockedPlays: plays.filter((play) => play.isLocked),
      unlockedPlays: plays.filter((play) => !play.isLocked),
    }
  }
)

export const getStatistics = createSelector([getAssessmentPlayData], (assessmentPlayList) => {
  if (Object.keys(assessmentPlayList).length > 0) {
    const completedAssessmentCount = get(assessmentPlayList, 'assessments', []).filter(
      (assessment) => assessment.isCompleted
    ).length
    const completedPlayCount = get(assessmentPlayList, 'plays', []).filter(
      (play) => play.isCompleted
    ).length
    let statisticsData: any = [
      {
        count: completedAssessmentCount || 0,
        statsInfo: 'Assessments Completed',
      },
      {
        count: completedPlayCount || 0,
        statsInfo: 'Plays Completed',
      },
    ]
    return statisticsData
  }
})

export const getCompletedPlaybook = createSelector(
  [getAssessmentPlayData],
  (assessmentPlayList) => {
    const completedAssessment = get(assessmentPlayList, 'assessments', []).filter(
      (assessment) => assessment.isCompleted
    )
    const completedPlay = get(assessmentPlayList, 'plays', []).filter((play) => play.isCompleted)
    let completedList: any = [...completedAssessment, ...completedPlay]

    completedList = completedList.map((list: any) => {
      return {
        ...list,
        completedAt: list.completedAt
          ? moment(list.completedAt).format('MMMM Do YYYY, h:mm:ss a')
          : '',
      }
    })

    completedList = completedList.sort(function (a, b) {
      return moment.utc(b.completedAt).diff(moment.utc(a.completedAt))
    })
    return completedList
  }
)

export const getInProgressPlaybook = createSelector(
  [getAssessmentPlayData],
  (assessmentPlayList) => {
    const inProgressAssessment = get(assessmentPlayList, 'assessments', []).filter(
      (assessment) => assessment.inProgress
    )
    const inProgressPlay = get(assessmentPlayList, 'plays', []).filter((play) => play.inProgress)

    let inProgressList: any = [...inProgressAssessment, ...inProgressPlay]

    return inProgressList
  }
)

export const getNotStartedPlaybook = createSelector(
  [getAssessmentPlayData],
  (assessmentPlayList) => {
    const inProgressAssessment = get(assessmentPlayList, 'assessments', []).filter(
      (assessment) => !assessment.isStarted
    )
    return inProgressAssessment
  }
)

export const getPlayValue = createSelector(
  [getAssessmentQuestion, getValue],
  (assessmentQuestion, play) => {
    let value: string = ''
    if (assessmentQuestion?.id) {
      const parsedData = JSON.parse(assessmentQuestion?.meta)
      if (
        isArray(parsedData?.value) &&
        Object.keys(parsedData?.playResponse || {}).includes(play.id)
      ) {
        value = parsedData.value
      } else if (
        assessmentQuestion?.id.includes(play?.meta?.questionType) &&
        Object.keys(parsedData?.playResponse || {}).includes(play.id)
      ) {
        value = assessmentQuestion.value
      }
    }
    return value
  }
)
export const getPlayResponse = createSelector(
  [getAssessmentQuestion, getValue],
  (assessmentQuestion: IAssessmentQuestion) => {
    if (assessmentQuestion?.id) {
      const parsedData = JSON.parse(assessmentQuestion?.meta)
      return parsedData?.playResponse
    }
  }
)
